import http from './http';
import {DialogProgrammatic as Dialog} from 'buefy';
import {appendModal, appendModalV2} from "../services/modals";
import PromptCancelStatusAutomations from "../components/modal/PromptCancelStatusAutomations.vue";

export default {
  getPipelineDeadRecords(queryString) {
    return http().get(`/v1/records/state/dead?${queryString}`);
  },
  // getExtraContactingData(recordId) {
  //   return http().get(`/v1/records/${recordId}/contacting_data`);
  // },
  getExtraContactingDataCollection(recordIds) {
    return http().post(`/v1/records/contacting_data_collection`, {
      record_ids: recordIds,
    });
  },
  getPipelineNonLeadRecords(queryString) {
    return http().get(`/v1/records/state/non_lead?${queryString}`);
  },
  getPipelineCompletedRecords(queryString) {
    return http().get(`/v1/records/state/completed?${queryString}`);
  },
  // getRecordFinancials(recordId) {
  //   return http().get(`v1/records/${recordId}/financials`);
  // },
  // getRecordsPreview(record_ids) {
  //   return http().post(`/v1/records/preview`, record_ids);
  // },
  attachContact(data) {
    return http().put(`/v1/records/${data.id}/attach_contact`, data);
  },
  getRecordsInFollowUpTemplate(followUpTemplateId) {
    return http().get(`/v1/records/preview/follow-up-sequence-template/` + followUpTemplateId);
  },
  // getArchivedRecords(archivedRecordEnum, query = '') {
  //   return http().get(`/v2/records/archived/${archivedRecordEnum.value}?` + query);
  // },
  // getSoldRecords() {
  //   return http().get(`/v2/records/archived/1`);
  // },
  // getDeadRecords() {
  //   return http().get(`/v2/records/archived/2`);
  // },
  // getSpamRecords() {
  //   return http().get(`/v2/records/archived/3`);
  // },
  // getRentedRecords() {
  //   return http().get(`/v2/records/archived/4`);
  // },
  get(id) {
    return http().get(`/v1/records/${id}`);
  },
  create(data) {
    return http().post(`/v2/records`, data);
  },
  updateLeadInfo(data) {
    return http().patch(`/v1/records/${data.id}/lead_info`, data);
  },
  updateLeadDetails(data) {
    return http().patch(`/v1/records/${data.id}/lead_details`, data);
  },
  update(data) {
    return http().put(`/v1/records/${data.id}`, data);
  },
  updateGoogleDrive(data) {
    return http().patch(`/v1/records/${data.id}/drive_integration`, data);
  },
  delete(recordId) {
    return http().delete(`/v1/records/${recordId}`);
  },
  bulkDelete(data) {
    return http().put(`/v1/records/bulk_delete_lead`, data);
  },
  search(data) {
    return http().put(`/v1/records/search`, data).then(response => {
      response.data = response.data.map(preview => {
        preview.address = this._address(preview);
        return preview;
      });

      return response;
    });
  },
  searchWithContacts(data) {
    return http().put(`/v1/records/search-with-contacts`, data).then(response => {
      response.data = response.data.map(preview => {
        preview.address = this._address(preview);
        return preview;
      });

      return response;
    });
  },
  _address(preview) {
    const line_1 = preview.line_1;
    const city = preview.city;

    if (line_1 && city && preview.state) {
      return `${line_1}, ${city} ${preview.state}`;
    }

    if (line_1 && city) {
      return `${line_1}, ${city}`;
    }

    if (line_1) {
      return line_1;
    }

    return 'Unknown Street';
  },

  changeStatus(recordId, statusId, dueAt, nextContactAt) {
    return http().put(`/v1/records/${recordId}/change_status`, {
        'status_id': statusId,
        'due_at': dueAt || null,
        'next_contact_at': nextContactAt || null,
      }).catch(error => {
        if (error.response.status === 422) {
          if (error.response.data.errors.ignore_automations) {
            return new Promise((resolve, reject) => {
              Dialog.confirm({
                title: 'Rerun Automations?',
                message: 'This lead has already been in this status. Would you like to rerun the automations that have already been run previously?',
                canCancel: ['button'],
                cancelText: 'No',
                confirmText: 'Rerun Automations',
                onConfirm: () => {
                  this.changeStatusSecondStepPrivateMethod(recordId, statusId, dueAt, nextContactAt, false)
                    .then(response => resolve(response), () => reject())
                },
                onCancel: () => {
                  this.changeStatusSecondStepPrivateMethod(recordId, statusId, dueAt, nextContactAt, true)
                    .then(response => resolve(response), () => reject())
                },
              });
            });
          }

          if (error.response.data.errors.has_incomplete_automations) {
            const automations = [
              ...error.response.data.errors.exit_automations,
              ...error.response.data.errors.time_automation,
            ]

            let $prompt = appendModal(PromptCancelStatusAutomations, this.$root, {
              automations: automations,
            });

            return $prompt.$on("confirmed", (runIncompleteAutomations) => {
              this.changeStatusIgnoreAutomationsCheck(recordId, statusId, dueAt, nextContactAt, runIncompleteAutomations)
                .then(res => {})
            });
          }
        }

        throw error;
      });
  },

  changeStatusSecondStepPrivateMethod(recordId, statusId, dueAt, nextContactAt, ignore_automations) {
    return http().put(`/v1/records/${recordId}/change_status`, {
      'status_id': statusId,
      'due_at': dueAt || null,
      'next_contact_at': nextContactAt || null,
      'ignore_automations': ignore_automations
    });
  },

  changeStatusIgnoreAutomationsCheck(recordId, statusId, dueAt, nextContactAt, runIncompleteAutomations) {
    return http().put(`/v1/records/${recordId}/change_status`, {
      'status_id': statusId,
      'due_at': dueAt || null,
      'next_contact_at': nextContactAt || null,
      'ignore_automations': false,
      'run_incomplete_automations': runIncompleteAutomations
    });
  },

  changeActiveStatusDueAt(recordId, dueAt) {
    return http().put(`/v1/records/${recordId}/change_active_status_due_at`, {
      'due_at': dueAt,
    });
  },
  // returnToPipeline(recordId) {
  //   return http().put(`/v1/records/${recordId}/take_out_of_following_up`);
  // },
  changeUsers(recordId, data) {
    return http().put(`/v1/records/${recordId}/change_users`, data);
  },
  // changeCampaign(recordId, campaignId) {
  //   return http().put(`/v1/records/${recordId}/change_campaign`, {
  //     'campaign_id': campaignId
  //   });
  // },
  getRecordProp(data) {
    return http().get(`/v1/records/${data.record_id}/${data.prop}`);
  },
  patch(data, prop) {
    return http().patch(`/v1/records/${data.id}/${prop}`, data);
  },
  deleteSpamRecords(data) {
    return http().put(`/v1/records/delete_spam_records`, data);
  },
  setActiveBuyingAnalysis(recordId, data) {
    return http().put(`/v1/records/${recordId}/set_active_buying_analysis`, data);
  },
  // setSeller(data) {
  //   return http().put(`/v1/records/${data.record_id}/set_seller`, data);
  // },
  // setBuyer(data) {
  //   return http().put(`/v1/records/${data.record_id}/set_buyer`, data);
  // },
  setPrimaryContact(data) {
    return http().put(`/v1/records/${data.record_id}/set_primary_contact`, data);
  },
  setActiveSellingInfo(recordId, data) {
    return http().put(`/v1/records/${recordId}/set_active_selling_info`, data);
  },
  updateBuyingInfoDates(data) {
    return http().put(`/v1/records/${data.record_id}/buying_info_dates`, data);
  },
  updateBuyingInfoStatus(data) {
    return http().put(`/v1/records/${data.record_id}/buying_info_status`, data);
  },
  removeContact(recordId, contactId) {
    return http().delete(`/v1/records/${recordId}/contacts/${contactId}`);
  },
  markAsDeal(recordId, data) {
    return http().put(`/v1/records/${recordId}/mark-as-deal`, data);
  },
  unmarkAsDeal(recordId) {
    return http().put(`/v1/records/${recordId}/unmark-as-deal`);
  },
  getDealRecords() {
    return http().get(`/v1/records/deals`);
  },
  getRecentlyViewedLeads() {
    return http().get(`/v1/records/recent-viewed-leads`);
  },
  markRecentViewedLead(recordId) {
    return http().put(`/v1/records/${recordId}/mark-recent-viewed-lead`);
  },
  setAddressed(recordId, data) {
    return http().put(`/v1/records/${recordId}/set-addressed`, data);
  },
  setNextContactAt(recordId, data) {
    return http().put(`/v1/records/${recordId}/set-next-contact-at`, data);
  },
  setTemperature(recordId, data) {
    return http().patch(`/v1/records/${recordId}/temperature`, data);
  },
  updateDealProbability(recordId, data) {
    return http().put(`/v1/records/${recordId}/deal-probability`, data);
  },
  bulkUpdateStatus(data) {
    return http().put('v1/records/bulk-status-changed', data);
  },
  bulkUpdateCampaign(data) {
    return http().put('v1/records/bulk-campaign-changed', data);
  },
  bulkUpdateTemperature(data) {
    return http().put('v1/records/bulk-temperature-changed', data);
  },
  bulkUpdateExitStrategy(data) {
    return http().put('v1/records/bulk-exit-strategy-changed', data);
  },

  /**
   * DUPLICATE LEADS ENDPOINTS
   */
  getDuplicateLeadList(recordId) {
    return http().get(`v1/records/${recordId}/duplicate_leads`)
  },
}
